// src/pages/Privacy.tsx
import React from "react";
import Header from "components/Header";
import Footer from "components/Footer";

export default function Privacy() {
  const Wrap: React.CSSProperties = {
    maxWidth: 720,
    margin: "0 auto",
    padding: "16px 14px 40px",
    lineHeight: 1.9,
    color: "#0b1a27",
    background: "#fff",
  };
  const H1: React.CSSProperties = {
    fontSize: 22,
    fontWeight: 800,
    letterSpacing: "0.02em",
    margin: "22px 0 10px",
    color: "#1e73be",
  };
  const P: React.CSSProperties = { margin: "10px 0" };
  const UL: React.CSSProperties = { paddingLeft: 24, margin: "8px 0" };

  return (
    // 下付きフッター & スクロール許可（bodyがoverflow:hiddenでも見えるように）
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#f5f7fb",
        overflowY: "auto",
      }}
    >
      {/* ← これが無いとヘッダーは表示されません */}
      <Header />

      <main style={{ flex: 1 }}>
        <div style={Wrap}>
          <h1 style={H1}>個人情報の利用目的</h1>
          <p style={P}>
            弊社では、以下の目的で個人情報を利用する事があります。万が一、当サイトの利用方法が以下の目的外の利用に該当する場合はメール等でご連絡させて頂きます。その際、お客様のご同意を頂けない場合は利用を停止致します。また、当サイトにて収集された個人情報に、オフラインや第三者から知り得た情報が補足される事はありません。
          </p>
          <ul style={UL}>
            <li>会員に、競馬等に関する情報、また特別なサービスや企画などの情報を的確にお知らせするため。</li>
            <li>会員が「ボート億MAN」のページ上で目にするコンテンツをカスタマイズするため。</li>
            <li>情報やサービスの内容を、より充実したものにする過程で、アンケートなどやログ解析を行うため。</li>
            <li>必要に応じて会員と連絡を取るため。</li>
            <li>
              必要な範囲内において、個人情報の取り扱いを委託し、メールや郵便物の処理と送付、会員サポートの提供、配送の手配、弊社サービスの統計分析処理等の特定のサービスを他社に委託する事があります。業務委託に関しては、機密保持契約を締結の上、必要な目的の範囲内で必要な情報のみを開示し、目的達成以外に個人情報を利用する事を禁止すると共に必要な管理監督を行っております。
            </li>
            <li>
              弊社及び弊社関連会社の運営する競馬サイトで提供する各種サービス、情報のご提案およびご案内、ならびにそれらのサイトにおいて提供するサービスの開発および改善。
            </li>
          </ul>

          <h1 style={H1}>個人情報の管理</h1>
          <p style={P}>
            弊社では、会員の個人情報の取り扱いに際し、管理責任者を置き、正確かつ最新の内容に保つよう努め、適切な管理を行うとともに、外部への流出防止に努めています。また、個人情報保護に関する社内教育を実施し、従業員の意識向上及び管理体制の強化に努めております。外部からの不正なアクセス、または紛失、破壊、改ざん等の危険に対しては、適切かつ合理的なレベルの安全対策を実施し、会員の個人情報の保護に努めています。
          </p>

          <h1 style={H1}>個人情報の開示</h1>
          <p style={P}>
            会員が、会員の個人情報の開示、訂正等を希望される場合には、会員に対する弊社窓口までご連絡頂ければ、会員本人が確認出来る合理的な範囲で速やかに対応させて頂きます。裁判所や警察等の公的機関から、法律に基づく正式な照会を受けた場合、またサイト上での会員の行為が、利用規約やガイドライン等に反し、弊社の権利、財産やサービス等を保護する為必要と認められる場合、または人の生命、身体および財産に対する差し迫った危険があり、緊急の必要性がある場合は、会員本人の同意を得る以前に開示する場合があります。
          </p>

          <h1 style={H1}>アクセスログ・クッキー</h1>
          <p style={P}>
            当サイトでは、アクセスされた方の情報をアクセスログとして記録しています。記録された情報には、アクセスされた方のIPアドレスや使用されているブラウザの種類等の情報が含まれますが、個人を特定出来る情報を含むものではありません。アクセスログは、当サイトの利用状況の分析やサイトの管理のために利用致します。また、当サイトではクッキーを使用しております。クッキーに含まれる情報にはお客様を特定するものは一切含まれておりませんし、これにより第三者に情報が開示される事もありません。尚、お客様のコンピュータの設定を変更する事により、当サイトから送付されるクッキーを受け取らないようにする事も出来ます。
          </p>

          <h1 style={H1}>リンク</h1>
          <p style={P}>
            当サイトでは、外部サイトへのリンクを含みますが、個人情報を共有するものではありません。リンク先サイトにて行われる個人情報の収集に関しては、弊社では一切責任を負えませんので、リンク先サイトの個人情報の取扱内容を必ずご参照下さい。
          </p>

          <h1 style={H1}>注意事項</h1>
          <p style={P}>
            弊社では、会員の皆様によって登録された個人情報の保護に細心の注意を払っています。ただし、インターネット上の掲示板など、他の会員が閲覧出来るサービス上に会員本人が自発的に個人情報を登録された場合、他の会員の目に触れたり、意図しない利用がなされる可能性がある事に十分にご留意下さい。弊社は以上の方針を改定する事があります。その場合すべての改定はこのホームページで通知致します。
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}
